
import EoCard from '../../EoCard/EoCard.vue'

export default {
  name: "PreprReferenceToPublicationCard",
  components: { EoCard },
  props: {
    /**
     * Prepr data of this element
     */
    data: {
      type: Object,
      default: () => {},
    },
    /**
     * Prop and attribute overwrites
     */
    overwrites: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Index
     */
    index: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      // Prepr data model
      dataModel: {
        id: null,
        items: {
          'nl-NL': null,
        },
        environment: {
          domain: null,
        },
        model: {
          id: null,
        },
      },
    }
  },
  computed: {
    normalizedData () {
      return {...this.dataModel, ...this.data}
    },
    modelName () {
      if (!this.normalizedData.model.id) { return null }
      return this.$library.prepr.models[this.normalizedData.model.id].name
    },
    to () {
      switch (this.modelName) {
        case 'teaser':
          return this.normalizedData.items['nl-NL'].url?.body || this.$link.publication(this.normalizedData.items['nl-NL'].reference?.items?.[0])
        default:
          return this.$link.publication(this.normalizedData)
      }
    },
    target () {
      return this.to?.startsWith('http') ? '_blank' : '_self'
    },
    title () {
      switch (this.modelName) {
        case 'person':
          return this.normalizedData.items['nl-NL'].name?.body
        case 'topic':
          return this.normalizedData.items['nl-NL'].name?.body
        case 'teaser':
            return this.normalizedData.items['nl-NL'].teaser?.body
        default:
          return this.normalizedData.items['nl-NL'].title?.body
      }
    },
    subtitle () {
      switch (this.modelName) {
        case 'person':
          return 'Lees meer over:'
        case 'program':
          return 'Meer over het programma:'
        case 'podcast':
          return 'Meer over de podcast:'
        case 'teaser':
          return this.normalizedData.items['nl-NL'].subtitle?.body
        default:
          return 'Lees ook over:'
      }
    },
    description () {
      switch (this.modelName) {
        case 'teaser':
          return this.normalizedData.items['nl-NL'].description?.body
        default:
          return undefined
      }
    },
    imageRaw () {
      let image = null
      switch (this.modelName) {
        case 'teaser':
          image = this.normalizedData.items['nl-NL'].image?.items?.[0]?.cdn_files?.items?.[0]?.url
          break
        case 'podcast':
          image = this.normalizedData.items['nl-NL'].logo?.items?.[0]?.cdn_files?.items?.[0]?.url
          break
        case 'community':
          image = this.normalizedData.items['nl-NL'].avatar?.items?.[0]?.cdn_files?.items?.[0]?.url
          image = image || this.normalizedData.items['nl-NL'].logo?.items?.[0]?.cdn_files?.items?.[0]?.url
          break
      }
      return image || this.normalizedData.items['nl-NL'].hero?.items?.[0]?.cdn_files?.items?.[0]?.url

    },
    image () {
      switch (this.modelName) {
        case 'person':
          return this.imageRaw?.replace('{format}', 'w_600%2Ch_600%2Cc_north')
        default:
          return this.imageRaw
      }
    },
    imageSquare () {
      return this.modelName === 'podcast'
    },
  },
}
